import Routes from "./routes/routes";

export const App = () => <Routes />;